var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"viewtools",staticClass:"myEZUIKit",attrs:{"id":'video-' + _vm.config.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }